import config from '../../config';
import { isDashboardLocalDebugMode, isLocalLikeHost } from '../../utils/environmentMode';

export const usersHost = config.config.api_users.admin.usersHost;
const LOCAL_BROWSER_USERS_HOST = 'http://127.0.0.1:8082';
const browserUsersHost = isDashboardLocalDebugMode() && isLocalLikeHost(usersHost) ? LOCAL_BROWSER_USERS_HOST : usersHost;

//Merchant routes
export const createSubMerchant = browserUsersHost + '/merchant/store/';
export const editMerchant = browserUsersHost + '/merchant/edit/';
export const editMerchantRole = browserUsersHost + '/merchant/edit/';
export const shipmentEndpoint = browserUsersHost + '/shipment/';
export const storePaymentProfile = storeId => browserUsersHost + '/payment/store-payment-profile/' + encodeURIComponent(storeId);
